import React from 'react';
import { Box } from '@mui/material';
import { __t } from '../../../i18n/t';
import { Ask, Callout } from '../../../components/wizardKit/basics';
import { CheckRow, LabeledInput } from '../../../components/wizardKit/controls';

interface SendStepProps {
  sendPush: boolean;
  sendSms: boolean;
  notificationTime: string | null;
  onChange: (patch: { sendPush?: boolean; sendSms?: boolean; notificationTime?: string | null }) => void;
  hasPlaceholderWithSms: boolean;
}

// Ritmo do cadastro em etapas (o mesmo do desconto v2): 28 px entre perguntas.
const containerSx = { display: 'flex', flexDirection: 'column', gap: 3.5, pt: 2.25, pb: 3.5, maxWidth: 968 };

const SendStep: React.FC<SendStepProps> = ({ sendPush, sendSms, notificationTime, onChange, hasPlaceholderWithSms }) => (
  <Box sx={containerSx}>
    <Ask
      id="q-canais"
      title="Por onde o cliente fica sabendo?"
      help={__t('O aviso sai a cada troca de nível, com o texto escrito em cada um deles.')}
    >
      <CheckRow checked={sendPush} onChange={() => onChange({ sendPush: !sendPush })}>
        Enviar notificação push
      </CheckRow>
      {/* SMS e WhatsApp ainda não saem pela campanha: aparecem desligados pra rede saber que vêm aí. */}
      <CheckRow checked={sendSms} onChange={() => onChange({ sendSms: !sendSms })} disabled>
        Enviar SMS (em breve)
      </CheckRow>
      <CheckRow checked={false} onChange={() => undefined} disabled>
        Enviar WhatsApp (em breve)
      </CheckRow>
      {hasPlaceholderWithSms && (
        <Callout tone="warn" role="alert" sx={{ maxWidth: 640 }}>
          {'{{nome_do_cliente}} só funciona no push; desligue o SMS ou tire o nome da mensagem dos níveis.'}
        </Callout>
      )}
    </Ask>

    <Ask id="q-horario" title="A que horas?">
      <LabeledInput
        id="envio-horario"
        label="Horário de envio (BRT)"
        type="time"
        width={260}
        hint="Em branco: envia assim que possível, a cada troca de nível."
        value={notificationTime || ''}
        onChange={(e) => onChange({ notificationTime: e.target.value || null })}
      />
    </Ask>
  </Box>
);

export default SendStep;
